import * as React from "react";
import { PropertyFiltersComponentProps } from "../typings";
import { UitkCheckbox } from "uitk-react-switch";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { withStores } from "stores";
import { observer } from "mobx-react";
import { UitkSpacing } from "uitk-react-spacing";

const CheckboxTracked = FlexClickTracker(UitkCheckbox);

export enum CheckboxModuleNameTypes {
  PROPERTY_FILTERS = "PropertyFilters",
  WIZARD_HOTEL_V2_HTG = "WizardHotelPWAv2HTG",
}

export const Checkbox = withStores(
  "propertyFilters",
  "wizardState"
)(
  observer((props: PropertyFiltersComponentProps) => {
    const { filterName, option, propertyFilters, wizardState, moduleName, onChange: handleChange } = props;

    const onChange = () => {
      const regionId = propertyFilters.toggleSelection(filterName, option.optionValue!);

      handleChange?.(filterName, option);

      if (regionId) {
        wizardState?.hotelWizardState?.setRegionId(regionId);
      }
    };

    const isSelected = propertyFilters.isSelected(filterName, option.optionValue!);

    const categoryName = option.filterCategory ?? filterName;

    return (
      <UitkSpacing margin="half">
        <div>
          <CheckboxTracked
            events="click"
            id={`${moduleName}-${filterName}-${option.optionValue}`}
            name={categoryName}
            label={option.label}
            moduleName={moduleName}
            rfrr={`${filterName}.${option.optionValue}.${!isSelected}`}
            value={option.optionValue}
            checked={isSelected}
            onChange={onChange}
            description={option.description}
            autoComplete="off"
          />
        </div>
      </UitkSpacing>
    );
  })
);
